import { defineStore } from 'pinia';
import { ProcessPoint } from 'hiber-grpc/src/customer_compiled/process_point';

export const useProcessPointsStore = defineStore('processPoints', {
  state: () =>
    ({
      _selectedItem: null,
    }) as { _selectedItem: ProcessPoint | null },
  actions: {
    setSelectedItem(item: ProcessPoint | null) {
      this._selectedItem = item;
    },
  },
  getters: {
    selectedItem(state) {
      return state._selectedItem;
    },
  },
});
